import { useMapContext } from 'widgets/earthMap/contexts/mapContext';
import { useEffect } from 'react';
import { SELECTED_FEATURE_PROPERTY } from 'widgets/earthMap/constants/mapConstants';
import { DEFAULT_CIRCLE_RADIUS, MIN_CIRCLE_RADIUS, MAX_CIRCLE_RADIUS } from 'widgets/earthMap/constants/circleSizes';

export default function useCircleRadius({ layerName, sourceName }) {
	const [{ map, min, max, selectedFeatureProperty }] = useMapContext();

	//CIRCLE RADIUS
	useEffect(() => {
		if (!map) return;
		const source = map.getSource(sourceName);
		if (!source) return;
		const layer = map.getLayer(layerName);
		if (!layer) return;
		if (isNaN(min) || isNaN(max) || min >= max || selectedFeatureProperty === undefined) {
			map.setPaintProperty(layerName, 'circle-radius', DEFAULT_CIRCLE_RADIUS);
			return;
		}
		map.setPaintProperty(layerName, 'circle-radius', [
			'interpolate',
			['linear'],
			['get', SELECTED_FEATURE_PROPERTY],
			min,
			MIN_CIRCLE_RADIUS,
			max,
			MAX_CIRCLE_RADIUS,
		]);
	}, [map, min, max, layerName, sourceName, selectedFeatureProperty]);
}
